import React from 'react';

const NebulaDecisionsFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaDecisionsModalRegistry = {
    personalize_nebulaDecisionsId: NebulaDecisionsFormModal
};
export default nebulaDecisionsModalRegistry;
